import React from "react"
import {CustomRegisterWrapper} from './style.jsx'
import {isApplyCustomLayout} from '../const.js'
const CustomRegister = ({children}) => {
  return <CustomRegisterWrapper isApplyCustomLayout={isApplyCustomLayout}>{children}</CustomRegisterWrapper>
}
export default CustomRegister



// WEBPACK FOOTER //
// ./src/common/custom-layout/CustomRegisterWrapper/index.js